export default __webpack_public_path__ + "static/imageEffect-6ccf5757b988ceb793e179e70794f475.png";